module.exports = __webpack_public_path__ + "img/home.dcd4a1ca.svg";